import { render, staticRenderFns } from "./assignStu.vue?vue&type=template&id=2188ff08&scoped=true&"
import script from "./assignStu.vue?vue&type=script&lang=js&"
export * from "./assignStu.vue?vue&type=script&lang=js&"
import style0 from "./assignStu.vue?vue&type=style&index=0&id=2188ff08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2188ff08",
  null
  
)

export default component.exports